import React, {Dispatch, SetStateAction} from 'react';

import {Button, TableBar, Tabs} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';
import {useRemappingFormatMessage} from '../../../../forecast-app/shared/util/FinancialInternationalisationUtil';
import {TABS} from './ProjectBreakdownTable';

interface ProjectBreakdownHeaderProps {
	tab: string;
	onExportCsv: () => void;
	onTabChange: Dispatch<SetStateAction<string>>;
	useBaseline: boolean;
}

const ProjectBreakdownHeader = ({
	tab,
	onTabChange,
	onExportCsv,
	useBaseline,
}: ProjectBreakdownHeaderProps): React.JSX.Element => {
	const formatMessage = useRemappingFormatMessage();

	const showTab = (messageId: string) => useBaseline || messageId !== TABS.baseline;

	return (
		<TableBar title={'Breakdown'} data-cy={'breakdown-table-bar'}>
			<Button emphasis={'medium'} onPress={onExportCsv}>
				<FormattedMessage id="common.export-csv" />
			</Button>
			<Tabs id={TableBar.ELEMENTS.TABS} value={tab} onValueChange={onTabChange}>
				<Tabs.List>
					{Object.values(TABS).map(
						messageId =>
							showTab(messageId) && <Tabs.Tab value={messageId}>{formatMessage({id: messageId})}</Tabs.Tab>
					)}
				</Tabs.List>
			</Tabs>
		</TableBar>
	);
};

export default ProjectBreakdownHeader;
